import category from 'components/forms/category/content'
import emergencyContact from 'components/forms/emergencyContact/content'
import participant from 'components/forms/participant/content'

const content = ({
  // for category form
  values,
  categories,
  onCategoryChange,
  currentRelayEvent,
  selectedRelayEvent,
  onRelayEventChange,
  fullShirtDetails,
  hasJersey,
  hasBibName,
  subCategories,

  // common
  formDisabled,
  updateField,
}) => [
  {
    id: 'update-category-form',
    name: 'Event',
    inputs: category({
      values,
      categories,
      onCategoryChange,
      currentRelayEvent,
      selectedRelayEvent,
      onRelayEventChange,
      fullShirtDetails,
      hasJersey,
      hasBibName,
      subCategories,
      formDisabled,
    }),
  },
  {
    id: 'update-participant-form',
    name: 'Participant',
    inputs: participant({ formDisabled, updateField }),
  },
  {
    id: 'update-emergencyContact-form',
    name: 'Emergency Contact',
    inputs: emergencyContact({ formDisabled, isOnsiteRegistration: true }),
  },
]

export default content
